/* global axios */
import ApiClient from './ApiClient';

class TeamMetricsAPI extends ApiClient {
  constructor() {
    super('team_metrics', { accountScoped: true });
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  getSupervisors(params = {}) {
    return axios.get(`${this.url}/supervisors`, { params });
  }

  getConsultants(params = {}) {
    return axios.get(`${this.url}/consultants`, { params });
  }

  getConsultantAttendance(params = {}) {
    return axios.get(`${this.url}/consultant_attendance`, { params });
  }

  getAvailableTeams() {
    return axios.get(`${this.url}/available_teams`);
  }
}

export default new TeamMetricsAPI();
